import { Outlet } from 'react-router-dom';
import Header from '../Header';
import Footer from '../Footer';
import BackToTop from '../BackToTop';
import ScrollToHash from '../../utils/ScrollToHash';
import ScrollToTop from '../../utils/ScrollToTop';

export default function Layout() {
  return (
    <>
      <ScrollToTop />
      <ScrollToHash />
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}
